import React from 'react';
import PropTypes from 'prop-types';
import {BasicTemplate} from '@wr/ui-patterns';

const PlatformTemplate = ({children, disableHeader, ...props}) => {
    const isMobile = Boolean(props.commonPageData?.platformData?.isMobile || props.commonPageData.isWebView);

    if (isMobile || disableHeader) {
        return children;
    }

    return (
        <BasicTemplate {...props}>
            {children}
        </BasicTemplate>
    );
};

PlatformTemplate.propTypes = {
    children: PropTypes.node.isRequired,
    commonPageData: PropTypes.shape({
        platformData: PropTypes.shape({
            isMobile: PropTypes.bool.isRequired
        }).isRequired,
        isWebView: PropTypes.bool.isRequired
    }).isRequired
};

export default PlatformTemplate;
